import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/cities')({
  staticData: { breadcrumb: 'Города' },
  component: () => <Outlet />,
});
